import { OverlayContainerView } from "./OverlayContainerView";
import { PreMatchOverlay } from "./Overlay/PreMatchOverlay";
import { PostMatchOverlay } from "./Overlay/PostMatchOverlay";
import { PostCupOverlay } from "./Overlay/PostCupOverlay";
import { PostGroupOverlay } from "./Overlay/PostGroupOverlay";
import { PostLeagueOverlay } from "./Overlay/PostLeagueOverlay";

export class TimelineOverlayContainerView extends OverlayContainerView {

    preMatchOverlay: PreMatchOverlay;
    postMatchOverlay: PostMatchOverlay;
    postGroupOverlay: PostGroupOverlay;
    postCupOverlay: PostGroupOverlay;
    postLeagueOverlay: PostLeagueOverlay;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'timelineOverlayContainerView';
        super( options );

        this.preMatchOverlay = this.addSubView( new PreMatchOverlay( { selector: '#pre_match_overlay' } ) );
        this.postMatchOverlay = this.addSubView( new PostMatchOverlay( { selector: '#post_match_overlay' } ) );
        this.postGroupOverlay = this.addSubView( new PostGroupOverlay( { selector: '#post_group_overlay' } ) );
        this.postCupOverlay = this.addSubView( new PostCupOverlay( { selector: '#post_cup_overlay' } ) );
        this.postLeagueOverlay = this.addSubView( new PostLeagueOverlay( { selector: '#post_league_overlay' } ) );
    }
}
